import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../../base-url';

const API_URL = baseUrl() + "/api/all/";

const getDataSanksi = 'data-sanksi-keanggotaan/';
const putDataSanksiUrl = 'data-sanksi-keanggotaan/';

class SanksiAnggotaService {    
    getData(id_user) {
        return axios.get(
            API_URL + getDataSanksi + id_user,
            {
                headers: authHeader()
            });
    }

    putDataSanksi(formData) {
        var headers = authHeader();
        return axios
            .put(
                API_URL + putDataSanksiUrl + formData.id_user, formData,
                { headers: authHeader() }
            );
    }

}

export default new SanksiAnggotaService();